<template><svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
<circle cx="7" cy="7" r="7"/>
<path d="M8 11C8 11.5523 7.55228 12 7 12C6.44772 12 6 11.5523 6 11C6 10.4477 6.44772 10 7 10C7.55228 10 8 10.4477 8 11Z" fill="white"/>
<path d="M7 2C7.55229 2 8 2.36254 8 2.80977V8.19023C8 8.63746 7.55229 9 7 9C6.44771 9 6 8.63746 6 8.19023V2.80977C6 2.36254 6.44771 2 7 2Z" fill="white"/>
</svg>
</template>